import { Directive, Input, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import { ReportViewResponse } from '../models/report-view.models';
import { PdfExportService } from '../services/pdf-export/pdf-export.service';

@Directive({
  selector: '[reportPdfExport]',
  standalone: false
})
export class ReportPdfExportDirective implements OnChanges, OnDestroy {
  private activeReportName?: string;

  @Input('reportPdfExport') reportView?: ReportViewResponse;

  constructor(private pdfExportService: PdfExportService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (!changes.reportView) {
      return;
    }

    if (this.activeReportName) {
      this.pdfExportService.deactivate(this.activeReportName);
      this.activeReportName = undefined;
    }

    if (!this.reportView) {
      return;
    }

    this.activeReportName = this.reportView.reportName;
    this.pdfExportService.activate(this.reportView.reportName, this.reportView.pdfEnabled === true);
  }

  ngOnDestroy(): void {
    if (this.activeReportName) {
      this.pdfExportService.deactivate(this.activeReportName);
    }
  }
}
